import {
  SelectItem,
  useCustomerTagsOptionsQuery,
} from '@kistill/client/data-access'
import { TextFieldProps } from '@mui/material'
import { AutocompleteElement } from 'react-hook-form-mui'

interface TagSelectorProps {
  name: string
  label: string
  inputProps?: TextFieldProps //þarf þetta??
}

export function KistillTagSelector({ name, label }: TagSelectorProps) {
  const { data } = useCustomerTagsOptionsQuery()

  const tagOptions = data?.customerTagsOptions?.map((x) => {
    return ({ id: x.id, label: x.title } as unknown as SelectItem) || undefined
  })

  return (
    <AutocompleteElement
      multiple
      name={name}
      label={label}
      options={tagOptions ?? []}
    />
  )
}
